import { useFormik } from "formik";
import { useEffect } from "react";

// Internal Imports
import { Mode } from "../../../common/types/AllTypes";
import { useForm } from "../../../contexts/form";
import { useListDepartmentByUer } from "../../../hooks/useListDepartment";
import { TypeVisualization } from "../../../interfaces/IForm";
import EditTextForm from "../../../common/components/EditTextForm/EditTextForm";
import GroupRow from "../../../common/components/GroupRow/GroupRow";
import MarginInput from "../../../common/components/MarginInput/MarginInput";
import Paint from "../../../common/components/Paint/Paint";
import SelectBox from "../../../common/components/SelectBox/SelectBox";
import { COLORS } from "../../../common/constants/colors";
import globalStyle from "../../../common/styles/globalStyle.module.css";
import useListTypeForm from "../../../hooks/useListTypeForm";
import useListStatusForm from "../../../hooks/useListStatusForm";
import DayInput from "../../../common/components/DayInput/DayInput";
import { fakeFormQuestion, initialFormQuestion } from "../../../common/constants/Utilities";
import { PreguntaTipo } from "../../../common/enums/AllEnums";
import useListTypeQuestion from "../../../hooks/useListTypeQuestion";

interface Props {
    setCanGoNext: React.Dispatch<React.SetStateAction<boolean>>;
    mode: Mode;
}

const StepOne = ({ setCanGoNext, mode }: Props) => {

    // States
    const { listDepartment, loadingDeparment } = useListDepartmentByUer();
    const { listTypeForm, loadingListTypeForm } = useListTypeForm();
    const { listStatusForm, loadingListStatusForm } = useListStatusForm();
    const { listTypeQuestion } = useListTypeQuestion();
    const { formQuestion, setFormQuestion } = useForm();

    // Methods
    const validations = (values: any) => {
        const errors: any = {};

        if (!values.nombre) {
            errors.nombre = "Requerido";
        }

        if (!values.departamentoGUID) {
            errors.departamentoGUID = "Requerido";
        }

        if (!values.visualizacionTipo) {
            errors.visualizacionTipo = "Requerido";
            errors.bloquearListado = "Requerido";
        } else {
            if (values.visualizacionTipo === TypeVisualization.Mapa.toString()) {
                if (!values.distancia) {
                    errors.distancia = "Requerido";
                } else if (parseInt(values.distancia) < 1) {
                    errors.distancia = "Debe ser mayor a 0";
                }
            } else if (values.visualizacionTipo === TypeVisualization.Listado.toString() || values.visualizacionTipo === TypeVisualization.ListadoDetalle.toString()) {
                if (!values.bloquearPaginacion) {
                    errors.bloquearPaginacion = "Requerido";
                }

                if (!values.cantidadRegistro) {
                    errors.cantidadRegistro = "Requerido";
                }
            }
            if (values.visualizacionTipo !== TypeVisualization.Tabla.toString() && (!values.bloquearPaginacion || values.bloquearPaginacion !== "true")) {
                if (!values.bloquearListado) {
                    errors.bloquearListado = "Requerido";
                }
            }
        }

        if (!values.esFormularioSecuencial) {
            errors.esFormularioSecuencial = "Requerido";
        }

        if (!values.cantidadMaximaLlenado && values.visualizacionTipo !== TypeVisualization.Tabla.toString()) {
            errors.cantidadMaximaLlenado = "Requerido";
        }

        if (!values.cantidadMaximaLlenadoDia && values.visualizacionTipo !== TypeVisualization.Tabla.toString()) {
            errors.cantidadMaximaLlenadoDia = "Requerido";
        } else if (parseInt(values.cantidadMaximaLlenado) !== 0 && parseInt(values.cantidadMaximaLlenadoDia) > parseInt(values.cantidadMaximaLlenado)) {
            errors.cantidadMaximaLlenadoDia = 'No puede ser mayor al Máximo Contestado';
        }

        if (!values.cantidadDiasHistorico) {
            errors.cantidadDiasHistorico = "Requerido";
        }

        if (!values.listadoNombre && values.visualizacionTipo !== TypeVisualization.Tabla.toString()) {
            errors.listadoNombre = "Requerido";
        }

        if (!values.diaSemana) {
            errors.diaSemana = "Requerido";
        }

        if (!values.diaSemana) {
            errors.diaSemana = "Requerido";
        }

        if (!values.formularioEstadoTipo) {
            errors.formularioEstadoTipo = "Requerido";
        }

        if (!values.fechaDesde) {
            errors.fechaDesde = "Requerido";
        }

        if (!values.fechaHasta) {
            errors.fechaHasta = "Requerido";
        } else if (new Date(values.fechaHasta)?.getTime() < new Date(values.fechaDesde)?.getTime()) {
            errors.fechaHasta = "No puede ser menor que Fecha Desde";
        }

        return errors;
    }

    // Form
    const FormQuestionFormik = useFormik({
        initialValues: { nombre: "", departamentoGUID: "", visualizacionTipo: "", esFormularioSecuencial: "", distancia: "", bloquearPaginacion: "", cantidadRegistro: "", cantidadMaximaLlenado: "", cantidadDiasHistorico: "", cantidadMaximaLlenadoDia: "", listadoNombre: "", diaSemana: "0000000", formularioEstadoTipo: "", fechaDesde: "", fechaHasta: "", bloquearListado: "", mostrarListadoDisponible: "" },
        validate: validations,
        onSubmit: (values: any) => console.log(values),
    });

    useEffect(() => {
        FormQuestionFormik.validateForm().then((response) => {
            if (!!formQuestion) {
                FormQuestionFormik.setValues({
                    nombre: formQuestion.nombre,
                    departamentoGUID: formQuestion.departamentoGUID,
                    visualizacionTipo: !!formQuestion.visualizacionTipo ? formQuestion.visualizacionTipo.toString() : "",
                    esFormularioSecuencial: formQuestion.esFormularioSecuencial.toString(),
                    distancia: !!formQuestion.distancia ? formQuestion.distancia.toString() : "",
                    bloquearPaginacion: formQuestion.bloquearPaginacion.toString(),
                    cantidadRegistro: formQuestion.cantidadRegistro.toString(),
                    cantidadMaximaLlenado: formQuestion.cantidadMaximaLlenado.toString(),
                    cantidadMaximaLlenadoDia: formQuestion.cantidadMaximaLlenadoDia.toString(),
                    cantidadDiasHistorico: formQuestion.cantidadDiasHistorico.toString(),
                    listadoNombre: !!formQuestion.listadoNombre ? formQuestion.listadoNombre : "",
                    diaSemana: formQuestion.diaSemana,
                    formularioEstadoTipo: !!formQuestion.formularioEstadoTipo ? formQuestion.formularioEstadoTipo.toString() : "",
                    fechaDesde: !!formQuestion.fechaDesde ? formQuestion.fechaDesde : "",
                    fechaHasta: !!formQuestion.fechaHasta ? formQuestion.fechaHasta : "",
                    bloquearListado: formQuestion.bloquearListado.toString(),
                    mostrarListadoDisponible: formQuestion.mostrarListadoDisponible.toString()
                });
            }

            if (JSON.stringify(response) == '{}') {
                setCanGoNext(true);
            } else {
                setCanGoNext(false);
            }
        });
    }, [])

    useEffect(() => {
        if (!!formQuestion) {
            setFormQuestion({
                ...formQuestion!,
                nombre: FormQuestionFormik.values.nombre,
                departamentoGUID: FormQuestionFormik.values.departamentoGUID,
                visualizacionTipo: parseInt(FormQuestionFormik.values.visualizacionTipo),
                visualizacionTipoNombre: listTypeForm.find(vt => vt.key.toString() === FormQuestionFormik.values.visualizacionTipo)?.value,
                esFormularioSecuencial: FormQuestionFormik.values.esFormularioSecuencial === "true" ? true : false,
                distancia: parseInt(FormQuestionFormik.values.distancia) || 0,
                bloquearPaginacion: FormQuestionFormik.values.bloquearPaginacion === "true" ? true : false,
                cantidadRegistro: parseInt(FormQuestionFormik.values.cantidadRegistro) || 0,
                cantidadMaximaLlenado: parseInt(FormQuestionFormik.values.cantidadMaximaLlenado) || 0,
                cantidadMaximaLlenadoDia: parseInt(FormQuestionFormik.values.cantidadMaximaLlenadoDia) || 0,
                cantidadDiasHistorico: parseInt(FormQuestionFormik.values.cantidadDiasHistorico) || 0,
                listadoNombre: FormQuestionFormik.values.listadoNombre,
                diaSemana: FormQuestionFormik.values.diaSemana,
                formularioEstadoTipo: parseInt(FormQuestionFormik.values.formularioEstadoTipo),
                fechaDesde: FormQuestionFormik.values.fechaDesde || null,
                fechaHasta: FormQuestionFormik.values.fechaHasta || null,
                bloquearListado: FormQuestionFormik.values.bloquearListado === "true" ? true : false,
                mostrarListadoDisponible: FormQuestionFormik.values.mostrarListadoDisponible === "true" ? true : false
            });
        }

        if (JSON.stringify(FormQuestionFormik.errors) == '{}') {
            setCanGoNext(true);
        } else {
            setCanGoNext(false);
        }
    }, [FormQuestionFormik.values, FormQuestionFormik.isValid, listTypeForm]);

    return (
        <div style={{ marginTop: 20 }}>
            <GroupRow>
                <MarginInput width="45%">
                    <label>Nombre:</label>
                    <EditTextForm
                        value={FormQuestionFormik.values.nombre}
                        onChange={FormQuestionFormik.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"nombre"}
                        placeholder={"Nombre"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.nombre && FormQuestionFormik.errors.nombre}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>Departamento:</label>
                    <SelectBox
                        value={FormQuestionFormik.values.departamentoGUID}
                        defaultValue={formQuestion?.departamentoGUID}
                        placeholder={"Departamento"}
                        disabled={false}
                        allowClear={false}
                        loading={loadingDeparment}
                        onChange={(value: string) => FormQuestionFormik.setFieldValue("departamentoGUID", value)}
                        options={listDepartment.map(dep => ({ key: dep.departamentoGUID, value: dep.departamentoGUID, text: dep.nombre }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.departamentoGUID && FormQuestionFormik.errors.departamentoGUID}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="45%">
                    <label>Tipo de visulización:</label>
                    <SelectBox
                        value={FormQuestionFormik.values.visualizacionTipo}
                        defaultValue={formQuestion?.visualizacionTipo}
                        placeholder={"Tipo de visulización"}
                        disabled={false}
                        allowClear={false}
                        loading={loadingListTypeForm}
                        onChange={(value: string) => { FormQuestionFormik.setValues({ ...FormQuestionFormik.values, visualizacionTipo: value, cantidadRegistro: "10", bloquearPaginacion: "false", distancia: "", listadoNombre: "", cantidadMaximaLlenado: "", cantidadMaximaLlenadoDia: "", bloquearListado: "true", mostrarListadoDisponible: "true" }) }}
                        options={listTypeForm.map(type => ({ key: type.value, value: type.key.toString(), text: type.value }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.visualizacionTipo && FormQuestionFormik.errors.visualizacionTipo}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="45%">
                    <label>¿Secuencial?:</label>
                    <SelectBox
                        value={FormQuestionFormik.values.esFormularioSecuencial}
                        defaultValue={formQuestion?.esFormularioSecuencial}
                        placeholder={"¿Secuencial?"}
                        disabled={false}
                        allowClear={false}
                        loading={false}
                        onChange={(value: string) => FormQuestionFormik.setFieldValue("esFormularioSecuencial", value)}
                        options={[{ key: 'secSi', value: 'true', text: 'Si' }, { key: 'secNo', value: 'false', text: 'No' }]}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.esFormularioSecuencial && FormQuestionFormik.errors.esFormularioSecuencial}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            {formQuestion?.visualizacionTipo === TypeVisualization.Mapa
                ?
                <GroupRow style={{ padding: '10px', backgroundColor: COLORS.white_color2(1), borderRadius: '5px' }}>
                    <MarginInput width="60%">
                        <label>Distancia (<Paint color={COLORS.blue_second(1)}>Metros</Paint>):</label>
                        <EditTextForm
                            value={FormQuestionFormik.values.distancia}
                            onChange={FormQuestionFormik.handleChange}
                            backgroundcolor={COLORS.white_color2(1)}
                            name={"distancia"}
                            placeholder={"Distancia"}
                            borderColor={COLORS.black_text_color3}
                            textColor={COLORS.black_text_color1}
                            active={true}
                            type={'number'}
                        />
                        <p className={globalStyle.error}>
                            <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.distancia && FormQuestionFormik.errors.distancia}</Paint>
                        </p>
                    </MarginInput>

                    <MarginInput width="30%" style={{paddingBottom : '1.875rem'}}>
                        <label>¿Mostrar Solo Listado Disponible?:</label>
                        <SelectBox
                            value={FormQuestionFormik.values.mostrarListadoDisponible}
                            defaultValue={formQuestion?.mostrarListadoDisponible}
                            placeholder={"Mostrar Listado Disponible"}
                            disabled={false}
                            allowClear={false}
                            loading={false}
                            onChange={(value: string) => FormQuestionFormik.setFieldValue("mostrarListadoDisponible", value)}
                            options={[{key: 'listSi', value: 'true', text: 'Si'}, {key: 'listNo', value: 'false', text: 'No'}]}
                            backgroundColor={COLORS.white_color2(1)}
                            borderColor={COLORS.black_text_color3}
                            textColor={COLORS.black_text_color1}
                        />
                    </MarginInput>
                </GroupRow>

                :
                (formQuestion?.visualizacionTipo === TypeVisualization.Listado || formQuestion?.visualizacionTipo === TypeVisualization.ListadoDetalle)
            }

            <GroupRow>
                <MarginInput width="20%">
                    <label>¿Bloquear Listado?:</label>
                    <SelectBox
                        value={FormQuestionFormik.values.bloquearListado}
                        defaultValue={formQuestion?.bloquearListado}
                        placeholder={"¿Bloquear Listado?"}
                        disabled={(formQuestion?.visualizacionTipo === TypeVisualization.Tabla || formQuestion?.bloquearPaginacion == true)}
                        allowClear={false}
                        loading={false}
                        onChange={(value: string) => FormQuestionFormik.setFieldValue("bloquearListado", value)}
                        options={[{ key: 'secSi', value: 'true', text: 'Si' }, { key: 'secNo', value: 'false', text: 'No' }]}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.bloquearListado && FormQuestionFormik.errors.bloquearListado}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="30%">
                    <label>Listado Nombre:</label>
                    <EditTextForm
                        value={FormQuestionFormik.values.listadoNombre}
                        onChange={FormQuestionFormik.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"listadoNombre"}
                        placeholder={"Listado Nombre:"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={formQuestion?.visualizacionTipo !== TypeVisualization.Tabla}
                        type={'text'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.listadoNombre && FormQuestionFormik.errors.listadoNombre}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="40%">
                    <label>Días de la semana:</label>
                    <DayInput
                        value={FormQuestionFormik.values.diaSemana}
                        onChange={(value: string) => FormQuestionFormik.setFieldValue('diaSemana', value)}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.diaSemana && FormQuestionFormik.errors.diaSemana}</Paint>
                    </p>
                </MarginInput>

            </GroupRow>

            <GroupRow>
                <MarginInput width="30%">
                    <label>Máximo Contestado (<Paint color={COLORS.blue_second(1)}>0 es Ilimitado</Paint>):</label>
                    <EditTextForm
                        value={FormQuestionFormik.values.cantidadMaximaLlenado}
                        onChange={FormQuestionFormik.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"cantidadMaximaLlenado"}
                        placeholder={"Máximo Llenado"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={formQuestion?.visualizacionTipo !== TypeVisualization.Tabla}
                        type={'number'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.cantidadMaximaLlenado && FormQuestionFormik.errors.cantidadMaximaLlenado}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="30%">
                    <label>Contestado al día (<Paint color={COLORS.blue_second(1)}>0 es Ilimitado</Paint>):</label>
                    <EditTextForm
                        value={FormQuestionFormik.values.cantidadMaximaLlenadoDia}
                        onChange={FormQuestionFormik.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"cantidadMaximaLlenadoDia"}
                        placeholder={"Contestado al día"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={formQuestion?.visualizacionTipo !== TypeVisualization.Tabla}
                        type={'number'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.cantidadMaximaLlenadoDia && FormQuestionFormik.errors.cantidadMaximaLlenadoDia}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="30%">
                    <label>Días en el Histórico:</label>
                    <EditTextForm
                        value={FormQuestionFormik.values.cantidadDiasHistorico}
                        onChange={FormQuestionFormik.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"cantidadDiasHistorico"}
                        placeholder={"Días en el Histórico"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'number'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.cantidadDiasHistorico && FormQuestionFormik.errors.cantidadDiasHistorico}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

            <GroupRow>
                <MarginInput width="30%">
                    <label>Estado:</label>
                    <SelectBox
                        value={FormQuestionFormik.values.formularioEstadoTipo}
                        defaultValue={formQuestion?.formularioEstadoTipo}
                        placeholder={"Estado"}
                        disabled={false}
                        allowClear={false}
                        loading={loadingListStatusForm}
                        onChange={(value: string) => FormQuestionFormik.setFieldValue("formularioEstadoTipo", value)}
                        options={listStatusForm.map(statusType => ({ key: statusType.value, value: statusType.key.toString(), text: statusType.value }))}
                        backgroundColor={COLORS.white_color2(1)}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.formularioEstadoTipo && FormQuestionFormik.errors.formularioEstadoTipo}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="30%">
                    <label>Desde:</label>
                    <EditTextForm
                        value={FormQuestionFormik.values.fechaDesde?.split('T')[0]}
                        onChange={FormQuestionFormik.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"fechaDesde"}
                        placeholder={"Desde"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'date'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.fechaDesde && FormQuestionFormik.errors.fechaDesde}</Paint>
                    </p>
                </MarginInput>

                <MarginInput width="30%">
                    <label>Hasta:</label>
                    <EditTextForm
                        value={FormQuestionFormik.values.fechaHasta?.split('T')[0]}
                        onChange={FormQuestionFormik.handleChange}
                        backgroundcolor={COLORS.white_color2(1)}
                        name={"fechaHasta"}
                        placeholder={"Hasta"}
                        borderColor={COLORS.black_text_color3}
                        textColor={COLORS.black_text_color1}
                        active={true}
                        type={'date'}
                    />
                    <p className={globalStyle.error}>
                        <Paint color={COLORS.red_error2}>{FormQuestionFormik.errors.fechaHasta && FormQuestionFormik.errors.fechaHasta}</Paint>
                    </p>
                </MarginInput>
            </GroupRow>

        </div>
    );
}

export default StepOne;